<template>
  <div>
    <vx-card>
      <ListBlocklistCorretoras
        :subjectPermission="subjectPermission"
      ></ListBlocklistCorretoras>
    </vx-card>
  </div>
</template>

<script>
import ListBlocklistCorretoras from './../../lists/ListBlocklistCorretoras';

export default {
  data() {
    return {
      subjectPermission: 'Blocklist Corretoras',
    };
  },
  methods: {},
  components: {
    ListBlocklistCorretoras,
  },
};
</script>
